class OpenGalleryButton extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();
  }

  connectedCallback() {
    this.addEventListener("click", () => {
      var child = this.parentNode;
      var parent = child.parentNode;
      // The equivalent of parent.children.indexOf(child)
      var index = Array.prototype.indexOf.call(parent.children, child);
      console.log("child: ", index);

      console.log(
        document.querySelectorAll(
          ".product__info-wrapper variant-radios input[type=radio]:checked"
        )
      );
      let thisHandle = [];
      document
        .querySelectorAll(
          ".product__info-wrapper variant-radios input[type=radio]:checked"
        )
        .forEach((el) => {
          thisHandle.push(el.dataset.handle);
        });
      thisHandle = thisHandle.join("-");

      let gallery = document.querySelector(`.${thisHandle}`);

      document.querySelectorAll(".swiper-pagination-bullet");

      gallery.classList.remove("hidden");
      document.querySelector("popup-background").classList.remove("hidden");
      document.querySelector("body").classList.add("no-scroll");
    });
  }
}

class MobilePopupGallery extends HTMLElement {
  constructor() {
    // Always call super first in constructor
    super();

    this.closeButton = this.querySelector(".close-btn");
    this.background = document.querySelector("popup-background");
    this.swiper = this.querySelector(".mySwiper");
  }

  connectedCallback() {
    var swiper = new Swiper(this.swiper, {
      zoom: true,
      navigation: {
        nextEl: ".swiper-button-next",
        prevEl: ".swiper-button-prev",
      },
      pagination: {
        el: ".swiper-pagination",
        clickable: true,
      },
    });

    this.closeButton.addEventListener("click", () => {
      this.classList.add("hidden");
      this.background.classList.add("hidden");
      document.querySelector("body").classList.remove("no-scroll");
    });
  }
}

customElements.define("mobile-popup-gallery", MobilePopupGallery);
customElements.define("mobile-zoom-button", OpenGalleryButton);
